import React, { useState } from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { useTranslation } from "react-i18next";
import AttachmentDialog from "./AttachmentDialog";
import Grid from "@mui/material/Grid";
import Button from "../inputs/Button";
import { styled } from '@mui/material/styles';

const MessageBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isQuestion'
})(({ theme, isQuestion }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    ...(isQuestion ? {
        // User question - left aligned, subtle background
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderLeft: `3px solid ${theme.palette.text.secondary}`,
    } : {
        // Support answer - right aligned feel, primary accent
        backgroundColor: 'rgba(255, 145, 0, 0.08)',
        borderLeft: `3px solid ${theme.palette.primary.main}`,
    }),
}));

const MessageText = styled(Typography)({
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
});

const Message = ({ message }) => {
    const { t } = useTranslation();
    const isQuestion = message.Type === "question";

    // File attachments from contact form
    const initialFileAttachments = message.File.filter(
        (file) => file.Mime !== "text/plain" && file.Mime !== "text/html"
    );

    // Part attachments from email client
    let initialPartsAttachments = [];
    message.File.forEach((file) => {
        Object.keys(file.Part ?? []).forEach(partKey => {
            const part = file.Part[partKey];
            if (part.Mime !== "text/plain" && part.Mime !== "text/html")
                initialPartsAttachments.push(part);
        });
    });

    const [fileAttachments] = useState(initialFileAttachments);
    const [partAttachments] = useState(initialPartsAttachments);
    const [showAttachments, setShowAttachments] = useState(false);

    const hasAttachments = fileAttachments.length + partAttachments.length > 0;

    return (
        <MessageBox isQuestion={isQuestion}>
            <MessageText variant="body2" color="text.primary">
                {message.Message}
            </MessageText>
            {hasAttachments && (
                <Grid container justifyContent="flex-end" sx={{ mt: 1 }}>
                    <Grid item>
                        <Button
                            size="small"
                            startIcon={<AttachmentIcon />}
                            onClick={() => setShowAttachments(true)}
                        >
                            {t('message_attachments_btn', { count: fileAttachments.length + partAttachments.length })}
                        </Button>
                    </Grid>
                </Grid>
            )}
            {hasAttachments && (
                <AttachmentDialog
                    open={showAttachments}
                    setOpen={setShowAttachments}
                    fileAttachments={fileAttachments}
                    partAttachments={partAttachments}
                />
            )}
        </MessageBox>
    );
};

export default Message;